<template>
    <div 
        class="modal fade" 
        tabindex="-1"
        role="dialog"
        v-bind:id="modalId"
        v-bind:aria-labelledby="label"
        v-bind:aria-hidden="hidden"
        >
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <slot name="header" class="modal-header">
                </slot>
                <slot name="body" class="modal-body">
                </slot>            
                <slot>
                </slot>
                <slot name="footer" class="modal-footer">
                </slot>
                
            </div>
        </div> 
    </div>
</template>

<script>
export default {
  name: "vue-modal",
  props: {
    modalId: {
        type: String,
        required: true
    },
    label: String,
    hidden: Boolean
  },
  ready: function() {

  },
  methods: {

  }
};
</script>



